const NUMBER_TABLE_PER_PAGE = 10;
export default NUMBER_TABLE_PER_PAGE;
